export default "__VITE_ASSET__BQU1AIm3__"